import React from 'react';
import {Grid, Row, Button} from 'react-bootstrap';
import {LexemeEditingLevel} from './../../editor/LexemeHelper';
import {LexemeNavigator} from './../../../../dict-components/components';
import {getLexemeProperties, LexemePageContent} from './../../LexemePage';
import {SubEntryCombo} from './../../../../dict-components/components';
import './../../../../lexeme/page/parts/03_Subentries/parts/LexemeSenses.css'
import './../../../../_css/lexeme.css';
import Dict from "dict-lib";
import ReactDOM from "react-dom";


export class EntryShowFrontendPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentWillMount() {
        var id = this.props.item.lexeme_properties.root_entry_id;

        Dict.call('/page/getPageById/' + id + '/').then(result => {
            const StandAloneLexemePageConst = result.page.isFrontendValid ? <LexemePageContent
                    key={"key-show-fe-page" + id}
                    page={result.page} pageStatus={LexemeEditingLevel.READ_ONLY}
                    classType={'ENTRIES'}
                    /*startItem={this.props.startItem}*/
                    status={'SET_PAGE'}
                    callBackSelectionHandler={(selectableItem) => this._callBackSelectionHandler(selectableItem)}/> :
                <div style={{fontSize: '20px'}}>{Dict.t('LEXEME_NOT_AVAILABLE_IN_FRONTEND')}</div>;
            ReactDOM.render(StandAloneLexemePageConst, document.getElementById('show-frontend-page'));
        });
    }


    render() {
        return <Grid className={'container-show-frontend-page'} id={'show-frontend-page'} fluid>
        </Grid>
    }
}